import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChiefGuestHistoryLayer from "../components/ChiefGuestHistoryLayer";

const ChiefGuestHistoryPage = () => {
  return (
    <>
      <MasterLayout>
        <ChiefGuestHistoryLayer />
      </MasterLayout>
    </>
  );
};

export default ChiefGuestHistoryPage;
